import { type BaseRecord, type HttpError, useOne } from '@refinedev/core'

export const isNotFound = (error?: HttpError | null) =>
  error?.statusCode === 404

// A missing record is a page state, not an error toast or a retry.
export function useAdminRecord<T extends BaseRecord>(
  resource: string,
  id: string | undefined,
) {
  const { result, query } = useOne<T, HttpError>({
    resource,
    id,
    queryOptions: {
      enabled: Boolean(id),
      retry: (failureCount, error) => !isNotFound(error) && failureCount < 1,
    },
    errorNotification: (error) => (isNotFound(error) ? false : undefined),
  })
  return { record: result, query }
}
